import { render } from "./ClientAuthorizedAsAudienceComponent.vue?vue&type=template&id=90822106&scoped=true"
import script from "./ClientAuthorizedAsAudienceComponent.vue?vue&type=script&lang=js"
export * from "./ClientAuthorizedAsAudienceComponent.vue?vue&type=script&lang=js"

import "./ClientAuthorizedAsAudienceComponent.vue?vue&type=style&index=0&id=90822106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90822106"]])

export default __exports__